import { Box } from "@mui/material";
import "./_style.scss";
import {
  infoHeadTitleList,
  searchFormList,
  searchFormSchema,
  stepper,
} from "./parts";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { IAPI_STA009_Response } from "../../type/apiType";
import { httpAPI_FAC019, httpAPI_STA009 } from "./api/request";
import { RelocationFlag, SexFlug } from "../../assets/data/Constants";
import TkStepper from "../../components/atoms/TkStepper";
import dayjs from "dayjs";
import { FacilityList } from "../../type/apiType/IAPI_FAC019";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";

/**
 * SCRC060103 職員一覧　配置換え登録
 * @return SCRC060103 職員一覧　配置換え登録
 */
const SCRC060103 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const isDaiko = userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;
  const context = businessState.job_27;
  const [facilityList, setFacilityList] = useState<any>([]);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [selectFacility, setSelectFacility] = useState(
    location.state?.facilityNo ?? context?.facilityNo ?? ""
  );
  const [selectItem, setSelectItem] = useState<any>();
  const [resData, setResData] = useState<IAPI_STA009_Response>({});

  const pulldownFacilityList = (facilityList: FacilityList[]) => {
    let pulldownList =
      facilityList?.map((item) => {
        return {
          label: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
          value: item.facilityNo!,
        };
      }) ?? [];
    if (!isDaiko) {
      pulldownList.push({ label: "999:契約対象外施設", value: "999" });
    }

    setFacilityList(pulldownList);
  };

  async function openingScreen() {
    // プルダウン用有効施設一覧参照API 呼び出し
    try {
      const res = await httpAPI_FAC019({
        contractorNo,
        businessType: businessState.common?.businessType,
        relocationFlag: RelocationFlag["配置換え元"],
      });

      if (res.resultCd === "I0000") {
        pulldownFacilityList(res.facilityList!);
        setResData(res);

        //持回情報の編集を行う
        setBusinessState({
          ...businessState,
          job_27: {
            ...context,
            facilityList: res.facilityList,
          },
        });

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  const facilitySelect = async (event: any, search?: boolean) => {
    if (!search) {
      setSelectFacility(event);
      if (!event) {
        setBodyList([]);
        return;
      }
    }

    let nameValue = search
      ? event
      : selectFacility === event
      ? context?.nameForSearch
      : "";

    try {
      const res = await httpAPI_STA009({
        contractorNo,
        facilityNo: !search ? event : selectFacility,
        staffNameKanji: nameValue,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        const bodyInfoList = res.staffList?.map((item) => {
          const staff = (businessState?.job_27?.removeStaffList ?? []).find(
            (i: any) => i.staffNo === item.staffNo
          );

          return [
            {
              children:
                (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
              forSort: item.staffNo,
            },
            {
              children: item.birthday,
              align: "center",
              forSort: item.birthday,
            },
            {
              children: TkGetCode(SexFlug, item.sex),
              align: "center",
              forSort: item.sex,
            },
            {
              children: item.firstJoinDate,
              align: "center",
              forSort: item.firstJoinDate,
            },
            {
              children:
                staff?.removeFacilityNo && staff?.removeFacilityName
                  ? staff?.removeFacilityNo + ":" + staff?.removeFacilityName
                  : "",
              forSort: staff?.removeFacilityNo ?? "",
            },
            {
              children: staff?.removeDate
                ? dayjs(staff?.removeDate).format("YYYY/MM/DD")
                : "",
              align: "center",
              forSort: staff?.removeDate ?? "",
            },
          ];
        })!;
        setBodyList(bodyInfoList);

        setResData(res);
        setBusinessState({
          ...businessState,
          job_27: {
            ...context,
            removeStaffList: context?.removeStaffList?.map((i) => ({
              ...i,
              checkFlag: "0",
            })),
            removeFacilityList: res.facilityList,
            nameForSearch: nameValue,
          },
        });

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (isDaiko && (location.state?.facilityNo || context?.facilityNo)) {
      const facilityList = [
        {
          facilityNo: location.state?.facilityNo || context?.facilityNo,
          facilityName: location.state?.facilityName || context?.facilityName,
        },
      ];
      pulldownFacilityList(facilityList);
    } else if (context?.facilityNo) {
      pulldownFacilityList(context?.facilityList ?? []);
    } else {
      openingScreen();
    }

    let resArr = searchList.current;
    context?.nameForSearch &&
      (resArr.find((item: any) => item.keyword === "name")!.wantToSetValue =
        context?.nameForSearch);
    setStateSearchList([...resArr]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //配置換え入力ボタンクリック
  const changeClick = () => {
    if (!selectItem.length) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    }

    setState({
      ...state,
      errorMsgId: "",
    });

    let removeStaffList = _.cloneDeep(context?.removeStaffList ?? []);
    const facilityList = _.cloneDeep(context?.facilityList ?? []);

    let facilityName =
      facilityList?.find((item: any) => item.facilityNo === selectFacility)
        ?.facilityName || context?.facilityName;
    selectFacility === "999" && (facilityName = "契約対象外施設");

    selectItem?.forEach((i: any) => {
      let staff = resData.staffList?.[i]!;
      const data = {
        checkFlag: "1",
        facilityNo: selectFacility,
        facilityName,
        staffNo: staff.staffNo,
        staffName: staff.staffNameKanji,
        updateDateTime: staff.updateDateTime,
      };
      let target = removeStaffList?.find((i) => i.staffNo === staff.staffNo);
      if (target) {
        removeStaffList[removeStaffList.indexOf(target)] = {
          ...target,
          ...data,
        };
      } else {
        removeStaffList.push(data);
      }
    });

    setBusinessState({
      ...businessState,
      job_27: {
        ...context,
        facilityNo: selectFacility,
        facilityName,
        removeStaffList,
      },
    });

    navigate("/SCRC060104");
  };

  const registerClick = () => {
    let removeStaffList = context?.removeStaffList?.filter(
      (item) => item.removeFacilityNo
    );

    // 業務チェック
    if (!removeStaffList?.length) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0085E",
      });
      return;
    }

    setState({
      ...state,
      errorMsgId: "",
    });
    setBusinessState({
      ...businessState,
      job_27: {
        ...context,
        removeStaffList,
      },
    });

    navigate("/SCRC060105");
  };

  return (
    <Box data-testid="SCRC060103PageForTest" className="tkSCRC060103">
      <TkStepper steps={stepper} activeStep={0} />
      <TkInfoManual children={labelids.labelid.LBLC060103_01} rule={"\\n"} />
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}

      <TkFakeTableLine
        title="施設選択"
        type="selectForm"
        helpicon={true}
        helpText="配置換えの対象者が在籍している施設等を選択してください"
        selectPropsList={facilityList}
        setDefaultValue={
          facilityList.length
            ? location.state?.facilityNo ?? context?.facilityNo
            : ""
        }
        onChange={(e: any) => facilitySelect(e.target.value)}
        disabled={isDaiko}
      />
      {selectFacility && (
        <Box className="tkBetween">
          <TkSearchForm
            listData={stateSearchList}
            ruleSchema={searchFormSchema}
            onSearch={(e: any) => facilitySelect(e.name, true)}
          />

          <TkButton onClick={changeClick}>配置換え入力</TkButton>
        </Box>
      )}
      {selectFacility && (
        <TkDataTable
          headList={infoHeadTitleList}
          bodyList={bodyList}
          count={bodyList.length}
          pagin
          checkSection
          defaultRowsPerPage={10}
          onCheckSectionWidth={setSelectItem}
        />
      )}

      <Box className="tkButtonGroup">
        <TkBackButton />
        <TkButton onClick={registerClick}>設定</TkButton>
      </Box>
    </Box>
  );
};

export default SCRC060103;
